import React from 'react';

import { useSelector } from 'hooks';
import { Route } from 'react-router-dom';

import ProtectedRoute from 'components/shared/ProtectedRoute';

import { TabType } from '../BaseTabsRouting';

interface TabsRouterProp {
  page: string;
  views: TabType[];
  requiredGrants: string;
}

const TabsRouter: React.FC<TabsRouterProp> = ({
  page,
  views,
  requiredGrants
}) => {
  const grants = useSelector((state) => state.grants);

  return (
    <ProtectedRoute isAccessGranted={grants[requiredGrants]} redirectPath={'/'}>
      {views.map((tableView, key) => {
        return (
          <Route
            key={key}
            path={`/${page}&page=${tableView.name}`}
            element={<tableView.Component />}
          >
            {<tableView.Component />}
          </Route>
        );
      })}
    </ProtectedRoute>
  );
};

export default TabsRouter;
